export default __webpack_public_path__ + "static/peterImanual-bab7af976fa71395bfb10e577b770162.jpg";